import { r as registerInstance, h, e as Host } from './index-bfb2bce5.js';

const ttuiBadgeCss = ":host{font-size:0.75rem;margin:4px 0 0 8px;padding:2px 4px;border-radius:4px;background:#ffebd8}";

const TtuiBadge = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("ttui-typography", { "ttui-small": true }, h("slot", null))));
  }
};
TtuiBadge.style = ttuiBadgeCss;

export { TtuiBadge as ttui_badge };

//# sourceMappingURL=ttui-badge.entry.js.map